module.exports = __webpack_public_path__ + "static/media/instagram-logo.c31a8e07.svg";